import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { CHANGE_CONSENT_STATUS, LOAD_CLIENT_APPLICATIONS, LOAD_CLIENTS, DELETE_APPLICATION } from "../store/applications-list-actions";
import { APPLICATION_CONSENT_OBTAINED_DATE } from "../store/applications-list-getters";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import ConsentStatusInfo from "./consent-status-info.vue";
import Amplitude from "../../../../../../../../shared/utils/amplitude";
import InlineLoader from "@Shared/components/general/inline-loader.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
import * as moment from "moment";
import { kebabToSentence } from "@Shared/@Utils/helpers/text";
export default defineComponent({
  name: "ClientApplication",
  components: {
    InlinePrompt,
    ConsentStatusInfo,
    InlineLoader
  },
  props: {
    application: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    copyingApp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return _objectSpread(_objectSpread({}, this.application), {}, {
      deleting: false,
      localCopyingApp: false
    });
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), mapGetters("ApplicationsListStore", [APPLICATION_CONSENT_OBTAINED_DATE])), {}, {
    isViewOnly() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY;
    },
    getConsentObtainedDate() {
      var _this$consentObtained;
      return (_this$consentObtained = this.consentObtainedDate) != null ? _this$consentObtained : this.APPLICATION_CONSENT_OBTAINED_DATE(this.applicationId);
    },
    applicationStreet() {
      return this.application.propertyAddress ? this.application.propertyAddress.split(",")[0] : "";
    }
  }),
  watch: {
    application(value) {
      this.consentStatus = value.consentStatus;
    },
    copyingApp(val) {
      if (!val) this.localCopyingApp = false;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationsListStore", [CHANGE_CONSENT_STATUS, LOAD_CLIENT_APPLICATIONS, LOAD_CLIENTS, DELETE_APPLICATION])), {}, {
    applicationSourceMessage(coBrokeredFrom, applicationSource) {
      return isEmpty(coBrokeredFrom) ? kebabToSentence(applicationSource) : this.$t(`application.applicationSource`, {
        originatedAgent: coBrokeredFrom
      });
    },
    applicationLink(applicationId, clientUsername, agentUsername) {
      return `#/clients/applications/${clientUsername}?agentUsername=${agentUsername}&applicationId=${applicationId}`;
    },
    documentApplicationLink(applicationId, clientUsername, agentUsername) {
      return `#/clients/applications/${clientUsername}?tab=documents&agentUsername=${agentUsername}&applicationId=${applicationId}`;
    },
    updateConsentStatus(status, applicationId, clientUsername) {
      const currentDate = moment(new Date()).format("YYYY-MM-DD");
      this.CHANGE_CONSENT_STATUS({
        status,
        clientUsername,
        applicationId,
        date: status === "obtained" ? currentDate : null
      });
    },
    getConsentStatus(status) {
      return status || "Not Obtained";
    },
    disableStatus(selectedStatus, optionStatus) {
      return selectedStatus === optionStatus;
    },
    async removeApplication() {
      this.deleting = true;
      await this.DELETE_APPLICATION({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      this.deleting = false;
    },
    logAmplitudeEvent(action) {
      if (action === "document") return Amplitude.logEvent("Applications - open documents clicked");
      Amplitude.logEvent(`Applications - open ${action} clicked`);
    }
  })
});